import type { Vector2 } from "~/state/game-types";

/**
 * Check if a point intersects with a rotated pill shape
 */
export function pointIntersectsPill(
  pointX: number,
  pointY: number,
  startWorldPos: Vector2,
  endWorldPos: Vector2,
  radius: number,

  // computed values:
  lineLength: number,
  normalizedLineVector: Vector2,
  perpVector: Vector2,
): boolean {
  // Vector from start to voxel center
  const toVoxel = {
    x: pointX - startWorldPos.x,
    y: pointY - startWorldPos.y,
  };

  // Project the voxel center onto the line
  const projection =
    toVoxel.x * normalizedLineVector.x + toVoxel.y * normalizedLineVector.y;

  // Calculate the perpendicular distance from the line
  const perpDistance = Math.abs(
    toVoxel.x * perpVector.x + toVoxel.y * perpVector.y,
  );

  // Check if the voxel is within the rectangle part of the pill
  if (projection >= 0 && projection <= lineLength && perpDistance <= radius) {
    return true;
  }

  // Check if the voxel is within the start cap (circle)
  const distToStart = Math.sqrt(toVoxel.x * toVoxel.x + toVoxel.y * toVoxel.y);
  if (distToStart <= radius) {
    return true;
  }

  // Check if the voxel is within the end cap (circle)
  const toEnd = {
    x: pointX - endWorldPos.x,
    y: pointY - endWorldPos.y,
  };
  const distToEnd = Math.sqrt(toEnd.x * toEnd.x + toEnd.y * toEnd.y);
  if (distToEnd <= radius) {
    return true;
  }

  return false;
}
